export default __webpack_public_path__ + "static/media/Wllness_Goal.c4872650.svg";